export const kz = {
    dashboard: 'Бақылау панелі',
    usersManagement: 'Пайдаланушыларды басқару',
    logs: 'Белсенділік журналы',
    createCafe: 'Кафе құру',
    logout: 'Шығу',
    allCafes: 'Барлық мекемелер',
    all: 'Негізгі мәзір',
    users: 'Пайдаланушылар',
    activeMenus: 'Белсенді мәзірлер',
    modifiers: 'Модификаторлар / Қоспалар',
    mandatory: 'МІНДЕТТІ',
    multipleChoice: 'КӨП РЕТТІК ТАҢДАУ',
    pricePlus: 'Бағасы (+)',

    // Lead Form
    yourName: 'Сіздің атыңыз',
    yourCafes: 'Сіздің мекемелеріңіз',
    manage: 'Басқару',
    analytics: 'Аналитика',
    openMenu: 'Мәзірді ашу',
    viewMenu: 'Мәзірді ашу',
    network: 'Желі',
    password: 'Құпия сөз',
    tapToOpenMap: '*2GIS-те көру үшін басыңыз',
    tariffs: 'Жазылым',
    qrCodeMenu: 'QR-код',
    messages: 'Хабарламалар',
    support: 'Қолдау',
    account: 'Аккаунт',
    searchDishes: 'Тағамдарды іздеу...',
    noDishes: 'Тағамдар табылмады.',
    availability: 'Қолжетімді',
    stopList: 'Стоп-тізім',
    available: 'Қолжетімді',
    unavailable: 'Қолжетімсіз',
    addToCart: 'Себетке қосу',
    price: 'Бағасы',
    description: 'Сипаттамасы',
    nutrients: 'Тағамдық құндылығы',
    stickers: 'Белгілер',
    weight: 'Салмағы',
    proteins: 'Ақуыздар',
    fats: 'Майлар',
    carbs: 'Көмірсулар',
    calories: 'Ккал',
    grams: 'г',
    ml: 'мл',
    save: 'Сақтау',
    cancel: 'Бас тарту',
    editDish: 'Тағамды өңдеу',
    addDish: 'Тағамды қосу',
    category: 'Санат',
    name: 'Атауы',
    dishName: 'Тағам атауы',
    dishPrice: 'Бағасы',
    selectCategory: 'Санатты таңдаңыз',
    optionalInfo: 'Қосымша ақпарат (КБЖУ және белгілер)',
    uploadImage: 'Суретті осында сүйреңіз',
    uploadHint: 'немесе таңдау үшін басыңыз (PNG, JPG, 5МБ дейін)',
    activeIconTitle: 'Қолжетімді тағамдар',
    stopListIconTitle: 'Стоп-тізімдегі тағамдар',
    globalStopList: 'Жалпы стоп-тізім',
    returnToAvailability: 'Қолжетімді ету',
    stats24h: '24 сағаттағы қаралымдар',
    topDish: 'Танымал тағам',
    lastChanges: 'Соңғы өзгерістер',
    topDishesWidget: 'Үздік тағамдар',
    cafesLabel: 'Кафелер',
    nothingFoundHeader: 'Әттең!',
    nothingFoundText: 'Сіздің сұранысыңыз бойынша ештеңе табылмады.',
    clearSearch: 'Іздеуді тазалау',
    // New ones
    energyValueLabel: 'Энерг. құндылығы',
    noDescription: 'Сипаттамасы жоқ',
    downloadApp: 'Қосымшаны жүктеу',
    installSuccess: 'Қосымша сәтті орнатылды!',
    pwaFallbackTitle: 'Қосымшаны орнату',
    pwaFallbackMessage: 'Қосымшаны орнату үшін браузер мәзірін басыңыз (үш нүкте) және "Негізгі экранға қосу" немесе "Орнату" тармағын таңдаңыз.',
    remove: 'Жою',
    receiptTitle: 'ЧЕК',
    headerQty: 'Саны',
    subtotal: 'Тапсырыс сомасы:',
    serviceCharge: 'Қызмет көрсету',
    totalAmount: 'ЖИЫНЫ:',
    clearCart: 'Чекті тазалау',
    close: 'Жабу',
    nameHeader: 'Атауы',
    hidden: 'Жасырылған',
    drafts: 'Шимай нұсқалар',
    basicInfo: 'Негізгі деректер',
    variants: 'Нұсқалар',
    regularPrice: 'Қалыпты баға',
    addVariants: 'Нұсқаларды қосу',
    sizes: 'Өлшемдер',
    typesWithPhoto: 'Түрлері (суретпен)',
    optional: 'Қосымша',
    bannerManagement: 'Баннерлерді басқару',
    addNewBanner: 'Жаңа баннер қосу',
    titleOptional: 'Атауы (міндетті емес)',
    bannerImage: 'Баннер суреті',
    recommendedSize: '2:1 ұсынылады',
    saveChanges: 'Өзгерістерді сақтау',
    noTitle: 'Атаусыз',
    confirmation: 'Растау',
    areYouSure: 'Сенімдісіз бе?',
    yesDelete: 'Иә, жою',
    loading: 'Жүктелуде...',
    processing: 'Өңделуде...',
    dbError: 'ДҚ қатесі',
    tryAgain: 'Қайтадан байқап көру',
    systemOnline: 'Жүйе: Online',
    systemOffline: 'Жүйе: Offline',
    database: 'Деректер базасы',
    storage: 'Файлдар (Сақтау орны)',
    active: 'Белсенді',
    hiddenStatus: 'Жасырылған',
    edit: 'Өзгерту',
    delete: 'Жою',
    categoryManagement: 'Санаттарды басқару',
    categoryDescriptionPlaceholder: 'Сипаттама (қонақтарға хабарлама)',
    sections: 'Бөлімдер',
    newCategoryPlaceholder: 'Жаңа санат атауы (мыс. Сусындар)',
    add: 'Қосу',
    show: 'Көрсету',
    hide: 'Жасыру',
    categoriesEmpty: 'Санаттар тізімі бос.',
    settings: 'Баптаулар',
    basicSettings: 'Негізгі параметрлер',
    cafeName: 'Мекеме атауы',
    address: 'Мекенжай',
    servicePercent: 'Қызмет көрсету (%)',
    maintenanceMode: 'Техникалық қызмет көрсету режимі',
    maintenanceDesc: 'Мәзірді қонақтардан жасырады',
    saveSettings: 'Параметрлерді сақтау',
    profileData: 'Профиль деректері',
    firstName: 'Аты',
    lastName: 'Тегі',
    emailCannotBeChanged: 'Email өзгертуге болмайды',
    updateProfile: 'Профильді жаңарту',
    security: 'Қауіпсіздік',
    newPassword: 'Жаңа құпия сөз',
    minChars: 'Кемінде 6 таңба',
    confirmPassword: 'Құпия сөзді растаңыз',
    changePassword: 'Құпия сөзді өзгерту',
    passwordsDoNotMatch: 'Құпия сөздер сәйкес келмейді',
    passwordTooShort: 'Құпия сөз ең аз 6 таңбадан тұруы керек',
    passwordChangedSuccess: 'Құпия сөз сәтті өзгертілді',
    profileUpdated: 'Профиль жаңартылды',
    menuByCategories: 'Санаттар бойынша мәзір',
    quickDishSearch: 'Тағамды жылдам іздеу...',
    clickToChange: 'Өзгерту үшін басыңыз',
    editPhoto: 'Редакциялау',
    changePhoto: 'Өзгерту',
    publishedDraft: 'ЖАРИЯЛАНДЫ (ЖОБА)',
    saveDraft: 'Жоба ретінде сақтау',
    dishDeleted: 'Тағам жойылды',
    additional: 'Қосымша',
    welcomeAdmin: 'Админ панеліне қош келдііз!',
    noCafeMessage: 'Сіздің аккаунтыңызға бекітілген кафе жоқ сияқты. Платформа әкімшісіне хабарласыңыз.',
    categoryDeleteWarning: 'Санатта',
    dishes: 'тағам бар',
    deleteCategoryWarning: 'Егер оны жойсаңыз, бұл тағамдар "санатсыз" қалады.',
    deleteCategoryConfirm: 'Осы санатты жойғыңыз келе ме',
    categoryAdded: 'Санат қосылды!',
    dishAdded: 'Тағам сәтті қосылды!',
    dishDuplicated: 'Тағам көшірілді!',
    saved: 'Өзгерістер сақталды',
    categoryDeleted: 'Санат жойылды',
    categoryExists: 'Мұндай санат бар!',
    categoryUpdated: 'Санат жаңартылды',
    visible: 'Көрінеді',
    hiddenMsg: 'Жасырын',
    uploadError: 'Суретті жүктеу қатесі',
    saveError: 'Сақтау қатесі',
    updateError: 'Жаңарту қатесі',
    deleteError: 'Жою қатесі',
    accessError: 'Қол жеткізу қатесі',
    syncError: 'Синхрондау қатесі',
    networkError: 'Желі қатесі',
    uncategorized: 'Санатсыз',
    cafeNotFound: 'Кафе табылмады немесе сілтеме жарамсыз.',
    backToHome: 'Басты бетке оралу',
    loadingError: 'Мәзірді жүктеу кезінде қате орын алды.',
    maintenanceTitle: 'Техникалық жұмыстар',
    maintenanceText: 'Біз жақында ораламыз!',
    temporarilyClosed: 'Жақында ораламыз',
    menuSuspendedTitle: 'Мәзір уақытша қолжетімсіз',
    menuSuspendedText: 'Мекеме онлайн-мәзір жұмысын тоқтатты. Қызметкерлерге хабарласыңыз.',
    error: 'Қате',
    passwordRuleLength: 'Кемінде 6 таңба',
    passwordRuleUpper: 'Бас әріп',
    passwordRuleNumber: 'Сан',
    passwordRuleLatin: 'Тек латын таңбалары',
    passwordRuleMatch: 'Құпиясөздер сәйкес',
    currentPassword: 'Ағымдағы құпиясөз',
    enterPassword: 'Құпиясөзді енгізіңіз',
    enterNewPassword: 'Жаңа құпиясөзді енгізіңіз',
    incorrectPassword: 'Ағымдағы құпиясөз қате',
    // Login Page
    loginTitle: 'QR-table',
    loginSubtitle: 'Мекемеңізді оңай және тиімді басқарыңыз.',
    loginTab: 'Кіру',
    registerTab: 'Тіркелу',
    emailLabel: 'Email',
    passwordLabel: 'Құпия сөз',
    emailPlaceholder: 'your@email.com',
    passwordPlaceholder: '••••••••',
    signInButton: 'Кіру',
    signingInButton: 'Кіруде...',
    forgotPassword: 'Құпия сөзді ұмыттыңыз ба?',
    resetPasswordEmailSent: 'Құпия сөзді қалпына келтіру сілтемесі электрондық поштаңызға жіберілді',
    resetPasswordSuccess: 'Құпия сөз сәтті өзгертілді',
    loginLockout: 'Әрекеттер саны тым көп. 2 минуттан кейін қайталап көріңіз.',
    userNotFound: 'Пайдаланушы табылмады',
    registerInfoTitle: 'Тіркелу',
    registerInfoText: 'Аккаунт ашу үшін қолдау қызметіне хабарласыңыз.',
    backToLogin: 'Кіруге оралу',
    empowerTitle: 'Бизнесіңізді дамытыңыз',
    empowerDescription: 'Сандық мәзірді толық басқару. Қаралымдарды қадағалаңыз, тағамдарды басқарыңыз және табысыңызды арттырыңыз.',
    chefQuote1: '"Ұлы аспаз болғың келсе, ұлы аспаздармен жұмыс істеуің керек. Мен дәл солай істедім." — Гордон Рамзи',
    chefQuote2: '"Сіздің денеңіз ғибадатхана емес, бұл ойын-сауық саябағы. Сапардан ләззат алыңыз." — Энтони Бурден',
    chefQuote3: '"Тамақ — қарым-қатынас құралы. Ол арқылы біз эмоциялар мен мәдениетпен бөлісеміз." — Массимо Боттура',
    chefQuote4: '"Рецептің жаны жоқ. Сіз, аспаз ретінде, рецептке жан бітіруіңіз керек." — Томас Келлер',
    chefQuote5: '"Аспаздық — ғылым емес, бұл шыдамдылық пен құмарлықты талап ететін өнер." — Вольфганг Пак',
    chefQuote6: '"Жақсы тамақ — жиі, тіпті көбінесе, қарапайым тамақ." — Энтони Бурден',
    chefQuote7: '"Егер майдан қорықсаңыз — кілегей қолданыңыз." — Джулия Чайлд',
    chefQuote8: '"Біз алдымен көзбен жейміз, содан кейін ғана басқасымен." — Поль Бокюз',
    chefQuote9: '"Асүй — естеліктер туатын жер." — Ален Дюкасс',
    chefQuote10: '"Мен тамақ пісірмеймін. Мен әсер қалдырамын." — Хестон Блюменталь',
    chefQuotesTitle: 'Шефтер даналығы',
    // Common Dictionary Words
    sauces: 'Тұздықтар',
    spiciness: 'Ащылық',
    sugarLevel: 'Қант деңгейі',
    roastingLevel: 'Қуыру дәрежесі',
    ice: 'Мұз',
    toppings: 'Топпингтер',
    milk: 'Сүт',
    syrup: 'Сироп',
    sideDish: 'Гарнир',
    dressing: 'Тұздық (салат)',
    bread: 'Нан',
    exclude: 'Алып тастау',
    size: 'Өлшемі',
    volume: 'Көлемі',
    temperature: 'Температура',
    sugar: 'Қант',
    dough: 'Қамыр',
    addIngredients: 'Ингредиент қосу',
    tabNutrition: 'Белгілер және КБЖУ',
    selectedTags: 'Таңдалған',
    wineCountry: 'Ел',
    whiskeyType: 'Күшті ішімдік',
    allSections: 'Барлық бөлімдер',
    autoTranslate: 'Авто-аудару',
    autoTranslateCategory: 'Бүкіл санатты аудару',
    linkPlaceholder: 'Сілтеме (https://...)',
    confirmAutoTranslate: 'Автоматты аударманы бастағыңыз келетініне сенімдісіз бе? Аударымсыз өрістер автоматты түрде толтырылады.',
    timeRestriction: 'Уақыт бойынша шектеу',
    timeRestrictionHint: 'Санат пен оның тағамдары тек көрсетілген уақытта және күндерде көрсетіледі',
    availableFrom: 'Бастап',
    availableTo: 'Дейін',
    scheduleDays: 'Жұмыс күндері',
    allDays: 'Барлық күндер',
    day_1: 'Дс',
    day_2: 'Сс',
    day_3: 'Ср',
    day_4: 'Бс',
    day_5: 'Жм',
    day_6: 'Сб',
    day_7: 'Жс',
    scheduleActive: 'Қазір белсенді',
    scheduleInactive: 'Қазір қолжетімсіз',
    onlyAvailableTime: '%from% бастап %to% дейін қолжетімді',
    // Common Types
    withChicken: 'Тауық етімен',
    withShrimp: 'Креветкамен',
    withBeef: 'Сиыр етімен',
    withSalmon: 'Албыртпен (Лосось)',
    withPork: 'Шошқа етімен',
    withVegetables: 'Көкөністермен',
    classic: 'Классикалық',
    withCheese: 'Ірімшікпен',
    // Portions
    smallPortion: 'Кіші',
    mediumPortion: 'Орташа',
    largePortion: 'Үлкен',
    // Common Ingredients
    extraMeat: 'Ет қосылған',
    extraCheese: 'Ірімшік қосылған',
    mushrooms: 'Саңырауқұлақтар',
    bacon: 'Бекон',
    egg: 'Жұмыртқа',
    // Exclusions
    withoutOnion: 'Пиязсыз',
    sugarFree: 'Қантсыз',
    lactoseFree: 'Лактозасыз',
    glutenFree: 'Глютенсіз',
    // Preparation
    grilled: 'Грильде',
    steamed: 'Буда піскен',
    baked: 'Пеште піскен',
    // Temp
    hot: 'Ыстық',
    cold: 'Суық',
    // Common Categories
    catCombo: 'Комбо',
    catSalads: 'Салаттар',
    catAppetizers: 'Тіскебасарлар',
    catBurgers: 'Бургерлер',
    catBurgersAndDoners: 'Бургерлер мен Донерлер',
    catPizza: 'Пицца',
    catDrinks: 'Сусындар',
    catDesserts: 'Десерттер',
    catBreakfast: 'Таңғы ас',
    catLunch: 'Түскі ас',
    catMainCourses: 'Негізгі тағамдар',
    catSoups: 'Сорпалар',
    catSteaks: 'Стейктер',
    catCocktails: 'Коктейльдер',
    catTeaCoffee: 'Шай және кофе',
    catAlcohol: 'Алкоголь',
    catSides: 'Гарнирлер',
    catPasta: 'Паста',
    catFishAndSeafood: 'Балық және теңіз өнімдері',
    catHotDishes: 'Ыстық тағамдар',
    catKidsMenu: 'Балалар мәзірі',
    catPastries: 'Тәтті тоқаштар',
    catBakeryAndBread: 'Нан және тоқаш өнімдері',
    catColdDrinks: 'Суық сусындар',
    catHotDrinks: 'Ыстық сусындар',
    catStreetFood: 'Стрит Фуд',
    catHotAppetizers: 'Ыстық тіскебасарлар',
    catColdAppetizers: 'Суық тіскебасарлар',
    catBar: 'Бар',
    catAlcoholicDrinks: 'Алкогольді сусындар',
    catPastaAndRisotto: 'Паста және Ризотто',
    catSushiRolls: 'Роллдар',
    catNoodles: 'Кеспе',
    catFitnessMenu: 'Фитнес Мәзірі',
    confirmDelete: 'Тағамды жою',
    confirmDeleteMessage: 'Бұл тағамды жойғыңыз келетініне сенімдісіз бе',
    copy: 'Көшіру',
    tariffPlansTitle: 'Тарифтік жоспарлар',
    tariffPlansSubtitle: 'Бизнесіңіз үшін қолайлы құралдар жиынтығын таңдаңыз',
    planDescStart: 'Жылдам бастау үшін',
    planDescSmart: 'Ең танымал',
    planDescBusiness: 'Кәсіби мамандар үшін',
    popularBadge: 'Танымал',
    currentPlanLabel: 'Сіздің ағымдағы жоспарыңыз',
    connectBtn: 'Қосылу',
    helpWithChoice: 'Таңдауға көмек керек пе?',
    contactUs: 'Бізге хабарласыңыз',
    perMonth: '/ ай',
    featureMaxDishes: '15 тағамға дейін',
    featureQRMenu: 'QR-мәзір',
    featureBasicStats: 'Негізгі статистика',
    featureUnlimitedDishes: 'Шексіз тағамдар саны',
    featureMultilingualAI: 'Көптілділік (AI аударма 100 карта шектеуі)',
    featureModifiersVariants: 'Модификаторлар мен нұсқалар',
    feature2GisAuto: '2ГИС-ке автоматты түрде жүктеу',
    featureBanners: 'Баннерлер',
    featureAllSmart: 'Smart барлық функциялары',
    featureWaiterPanel: 'Даяшы панелі',
    featureTgBotWaiter: 'Даяшы үшін ТГ ботты байланыстыру',
    featureAiWaiterChoice: 'ЖИ даяшы қонаққа тағам таңдауға көмектеседі',
    featureDataEntry: 'Тағамдардың 100 позициясына дейін толтырып береміз',
    featureSubdomain: 'Жеке қосалқы домен (name-cafe.qr-table.kz)',
    featureMultilingual: 'Көптілділік',
    featureModifiers: 'Модификаторлар',
    feature2Gis: '2ГИС интеграциясы',
    upgradeBtn: 'Тарифті көтеру',
    downgradeBtn: 'Тарифті төмендету',
    translationError: 'Аудару қатесі. Балансты немесе API параметрлерін тексеріңіз.',
    sourceTextMissing: 'Алдымен орыс тілінде (RU) мәтінді енгізіңіз.',
    // Messages Component
    noDialogs: 'Диалогтар жоқ',
    selectDialog: 'Сол жақтан диалогты таңдаңыз',
    writeMessagePlaceholder: 'Хабарлама жазыңыз...',
    ticketInfo: 'Тикет',
    screenshotLink: 'Скриншот',
    statusNew: 'Жаңа',
    statusInProgress: 'Орындалуда',
    statusResolved: 'Шешілді',
    statusClosed: 'Жабық',
    problemDesc: 'Мәселе сипаттамасы:',
    // QR Code Generator
    qrCodeMenuTitle: 'QR-мәзір',
    preview: 'Алдын ала қарау',
    downloadPNG: 'PNG жүктеп алу',
    downloadSVG: 'SVG жүктеп алу',
    link: 'Сілтеме',
    qrLinkHelp: 'Қонақтар QR-кодты сканерлегенде осы сілтемені ашады.',
    appearance: 'Сыртқы түрі',
    patternColor: 'Өрнек түсі',
    backgroundColor: 'Фон түсі',
    establishmentLogo: 'Мекеме логотипі',
    currentLogo: 'Ағымдағы логотип',
    replaceFile: 'Файлды ауыстыру',
    logoNotSelected: 'Логотип таңдалмаған',
    upload: 'Жүктеу',
    fileTooBig: 'Файл тым үлкен! Максималды өлшем 2MB',
    uploadImageError: 'Суретті жүктеңіз (PNG, JPG)',
    linkCopied: 'Сілтеме көшірілді!',
    errorSavingQR: 'Параметрлерді сақтау сәтсіз аяқталды',
    errorUploadingLogo: 'Логотипті жүктеу кезіндегі қате: ',
    // Support Modal
    contactSupport: 'Қолдау қызметімен байланыс',
    topic: 'Өтініш тақырыбы',
    topicBilling: 'Жазылым / Төлем мәселесі',
    topicTech: 'Техникалық қате',
    topicFeature: 'Жақсарту ұсынысы',
    topicQR: 'QR-кодтар және басып шығару',
    topicOther: 'Басқа',
    ticketSubject: 'Хабарлама тақырыбы (қысқаша)',
    ticketSubjectPlaceholder: 'Мысалы: Аударма жұмыс істемейді',
    ticketDesc: 'Мәселені сипаттаңыз',
    ticketDescPlaceholder: 'Оқиғаны толығырақ сипаттаңыз...',
    screenshot: 'Скриншот немесе файл (міндетті емес)',
    attachFile: 'Файл қосу',
    changeFile: 'Өзгерту',
    sendTicket: 'Өтінішті жіберу',
    sending: 'Жіберілуде...',
    ticketSent: 'Өтініш жіберілді!',
    ticketSentDesc: 'Біз сіздің хабарламаңызды алдық және жақында жауап береміз.',
    // Contact Us Modal
    contactTitle: 'Бізбен байланыс',
    contactSubtitle: 'Тарифтер мен серіктестік сұрақтары бойынша',
    selectPlan: 'Тарифті таңдаңыз',
    iWantToConnect: 'Қосылғым келеді:',
    currentPlan: 'Ағымдағы тариф:',
    message: 'Хабарлама',
    messagePlaceholder: 'Мысалы: Business тарифін қосқым келеді',
    contactSuccess: 'Өтініш жіберілді!',
    contactSuccessDesc: 'Біз сізбен жақын арада байланысамыз.',
    // Analytics
    missedRevenue: 'Жоғалған табыс',
    missedClicks: '"Стоп-парақ" бойынша басулар',
    wantedToOrder: 'ТАПСЫРЫС БЕРГІСІ КЕЛЕДІ',
    searchInsights: 'Қонақтар не іздейді',
    notFound: 'табылмады',
    found: 'табылды',
    clicks: 'басу',
    totalViews: 'Қаралымдар',
    totalVisitors: 'Келушілер',
    uniqueVisitors: 'Бірегей қонақтар',
    totalMenuOpens: 'Мәзір ашылуы',
    topDishes: 'Танымал тағамдар',
    popularity: 'танымалдылық',
    stickerEfficiency: 'Белгілер тиімділігі',
    noStickerData: 'Белгілер бойынша деректер жоқ',
    preferences: 'Қалаулар',
    activityOverTime: 'Уақыт бойынша белсенділік',
    overview: 'Шолу',
    menuAnalysis: 'Мәзір талдауы',
    visualGraphics: 'Визуализация',
    estimatedLoss: 'Болжалды шығын',
    clicksInStopList: 'Стоп-тізімдегі кликтер',
    audienceLanguage: 'Аудитория тілі',
    menuLeaderboard: 'Мәзір көшбасшылары',
    needsAttention: 'Қолдау қажет',
    whatGuestsWant: 'Қонақтар сұранысы',
    hiddenGems: 'Жасырын әлеует',
    allDishesActive: 'Барлық мәзір белсенді!',
    visitorTraffic: 'Келушілер трафигі',
    categoryInterest: 'Санаттарға қызығушылық',
    noData: 'Деректер жоқ',
    analyticsSubtitle: 'Мекемеңіздің тиімділігін талдау',
    today: 'Бүгін',
    yesterday: 'Кеше',
    exportPDF: 'PDF-ке экспорттау',
    exporting: 'Экспортталуда...',
    frameStyle: 'Үлгі стилі',
    selectTemplate: 'Үлгіні таңдаңыз',
    downloadTemplate: 'Үлгіні жүктеу',
    templateNone: 'Жақтаусыз',
    templateSolid: 'Тұтас',
    templateLabel: 'Жапсырма',
    templateSticker: 'Стикер',
    templateWhiteCard: 'Ақ карта',
    templateDarkCard: 'Қара карта',
    logo: 'Логотип',
    logoTakenFromSettings: 'Негізгі параметрлерден логотип қолданылады',
    noLogoInSettings: 'Негізгі баптауларда логотип жүктелмеген',
    uploadLogo: 'Логотипті жүктеу',
    cafeDescription: 'Дәмхана сипаттамасы',
    cafeDescriptionPlaceholder: 'Мекемеңіз туралы қысқаша айтып беріңіз...',
    socialLinks: 'Әлеуметтік желілер',
    instagram: 'Instagram',
    whatsapp: 'WhatsApp',
    telegram: 'Telegram',
    website: 'Веб-сайт',
    maintenanceConfirm: 'Мәзірді қонақтардан жасырғыңыз келетініне сенімдісіз бе? Барлық белсенді QR кодтары уақытша техникалық жұмыс бетіне бағытталады.',

    // QR Code Generator Extended
    eyes: 'Көздер',
    colors: 'Түстер',
    patternStyle: 'Өрнек стилі',
    eyeOuterFrame: 'Көздің сыртқы жақтауы',
    eyeInnerDot: 'Көздің ішкі нүктесі',
    quickPalette: 'Жылдам палитра',
    frameText: 'Жақтаудағы мәтін',
    font: 'Қаріп',
    printA4: 'Басу (A4 Парағы)',
    quantityPerSheet: 'Парақтағы саны',
    createA4Sheet: 'A4 парағын жасау',
    a4ReadyMessage: 'A4 макеті 300 DPI басуға дайын.',
    qrStyle: {
        square: 'Шаршы',
        rounded: 'Дөңгеленген',
        dots: 'Нүктелер',
        classy: 'Классикалық',
        classyRounded: 'Классикалық дөңгеленген',
        extraRounded: 'Қатты дөңгеленген',
        dot: 'Нүкте'
    },
    qrColor: {
        pattern: 'Өрнек',
        background: 'Фон',
        eyeFrame: 'Көз жақтауы',
        eyeDot: 'Көз нүктесі',
        frame: 'Жақтау',
        text: 'Мәтін'
    },
    // PDF Report
    strategicIntelligence: 'Стратегия және Ұсыныстар',
    revenueRisk: 'Болжалды шығын',
    trafficInsights: 'Трафик Талдауы',
    menuBalance: 'Мәзір Теңгерімі',
    expertTip: 'Сарапшы Кеңесі',
    generatedDate: 'Жасалған Күн',
    scanMenu: 'Мәзір',
    analyticalReport: 'Аналитикалық Есеп',
    reportingPeriod: 'Есептік Кезең',
    topPerformingItems: 'Ең Танымал Тағамдар',
    attentionNeeded: 'Назар Аударуды Қажет Етеді',
    categories: 'Санаттар',
    rank: 'Орын',
    totalViewsLabel: 'Жалпы Қаралымдар',
    categoryShare: 'Үлес',
    // Table Management
    tableManagement: 'Үстелдерді басқару',
    tablesQR: 'Үстелдер QR',
    mainQR: 'Негізгі QR',
    generateRange: 'Авто-генерация',
    tableNumber: 'Үстел нөмірі',
    addTable: 'Қосу',
    tableExists: 'Бұл үстел бұрыннан бар',
    confirmDeleteTable: 'Бұл үстелді жойғыңыз келетініне сенімдісіз бе?',
    downloadQR: 'QR жүктеу',
    enterTableCount: 'Үстелдер санын енгізіңіз (мысалы 10):',
    errorAddingTable: 'Үстел қосу қатесі',
    noTables: 'Үстелдер әлі қосылмаған',
    addTableHint: 'Қонақтар QR-код арқылы тапсырыс бере алуы үшін үстелдер қосыңыз',
    deleteTable: 'Үстелді жою',
    tablesCount: 'үстел қосылды',
    tableNum: '№',
    range: 'Генерация',
    directLink: 'Тікелей сілтеме',
    actions: 'Әрекеттер',
    downloadAll: 'Барлығын жүктеу (ZIP)',
    downloadAllConfirm: 'Барлық QR-кодтарды жүктеуді бастау керек пе?',
    copyLink: 'Сілтемені көшіру',
    bulkDownload: 'Жаппай жүктеу',
    bulkDownloadConfirm: 'Барлық үстелдермен бір ZIP-архив жасау керек пе?',
    downloadComplete: 'ZIP-архив сәтті жасалды',
    personalizeQR: 'QR кодын баптаңыз',
    bulkGenTitle: 'Жаппай генерация',
    bulkGenDesc: 'Автоматты түрде жасалатын үстелдердің санын енгізіңіз (1-ден N-ге дейін).',
    generate: 'Жасау',
    tablesAdded: 'Үстелдер сәтті қосылды',
    wifiName: 'Wi-Fi атауы',
    wifiPassword: 'Wi-Fi құпия сөзі',
    gallery: 'Галерея',
    addPhoto: 'Фото қосу',
    orDragHere: 'немесе осында сүйреңіз',
    // AI Waiter
    aiWaiterTitle: 'Ақылды Даяшы',
    aiWaiterWelcome: 'Сәлем! Мен ЖИ-даяшымын. Бүгін не тапсырыс бергіңіз келеді?',
    aiWaiterPlaceholder: 'Мәзір туралы сұраңыз...',
    aiWaiterError: 'Қап! Мен сәл ойланып қалдым сияқты. Қайтадан сұрап көріңізші.',

    // Waiter Panel
    waiter_panel: 'Даяшы панелі',
    dark_mode: 'Түнгі режим',
    dark_mode_desc: 'Батареяны үнемдейді және көзді қорғайды',
    notifications: 'Хабарландырулар',
    push_notifications: 'Push-хабарландырулар',
    in_browser: 'Браузерде',
    tg_integration: 'Telegram интеграциясы',
    tg_integration_desc: 'ТГ-ға жеке хабарламалар жіберу',
    link_via_bot: 'Бот арқылы байланыстыру',
    my_tables: 'Менің үстелдерім',
    select_tables_desc: 'Өзіңіз қызмет көрсететін үстелдерді таңдаңыз',
    tg_notifications_desc: 'Тапсырыс туралы хабарландыруларды тікелей Telegram-нан алыңыз',
    connect_telegram: 'Telegram-ға қосылу',
    unlink_telegram: 'Telegram-ды ажырату',
    tg_connected: 'Telegram қосылған',
    refresh_status: 'Күйді жаңарту',
    tg_connect_hint: 'Көк түймені басып, ботқа START жіберіңіз, содан кейін Күйді жаңарту түймесін басыңыз',
    no_tables_found: 'Үстелдер табылмады',
    live_feed: 'Шақыртулар лентасы',
    all_clear: 'Бәрі тыныш',
    no_calls_for_tables: 'Үстелдеріңіз бойынша шақыртулар жоқ',
    no_active_calls: 'Белсенді шақыртулар жоқ',
    table: 'Үстел',
    min_short: 'мин',
    accept: 'Қабылдадым',
    open_bills: 'Ашық шоттар',
    no_bills_for_tables: 'Үстелдеріңіз бойынша шоттар жоқ',
    no_active_bills: 'Белсенді шоттар жоқ',
    back: 'Артқа',
    bill_empty: 'Шот бос',
    add_item: 'Тағы тапсырыс беру',
    close_bill: 'Шотты жабу',
    close_bill_confirm: 'Бұл шотты жабуға сенімдісіз бе?',
    'Позвать официанта': 'Даяшыны шақыру',
    'Счет (наличные)': 'Шот (қолма-қол)',
    'Счет (карта)': 'Шот (карта)',
    'Дозаказ': 'Қосымша тапсырыс',
    calls: 'Шақыртулар',
    bills: 'Шоттар',
    feed: 'Лента',
    orders: 'Тапсырыстар',
    history: 'Тарих',
    menu: 'Мәзір',
    history_empty: 'Тарих бос',
    bill_paid: 'Шот төленді',
    notes_hint: 'Қалыпты жазбалар 24 сағат сақталады. Бекітілгендері — жойылғанша.',
    notes_all: 'Барлығы',
    notes_global: 'Жалпы',
    notes_tables: 'Үстелдер бойынша',
    no_notes: 'Жазбалар жоқ',
    new_note: 'Жаңа жазба',
    edit_note: 'Жазбаны өңдеу',
    add_note: 'Жазба қосу',
    pin_note: 'Жазбаны бекіту',
    note_text_placeholder: 'Жазба мәтіні...',
    post_note: 'Жариялау',
    delete_note_confirm_title: 'Жазбаны жою керек пе?',
    delete_note_confirm_msg: 'Бұл әрекетті болдырмау мүмкін емес.',
    pin: 'Бекіту',
    waiter_notes_global: 'Жалпы',
    language: 'Тіл',
    refresh: 'Жаңарту',
    notes: 'Жазбалар',
    chat_id: 'Чат ID',
    ok: 'ОК',
    show_qr_to_waiter: 'Официантқа QR көрсету',
    scan_guest_qr: 'Қонақ QR-ын сканерлеу',
    order_found: 'Тапсырыс табылды',
    accept_and_save: 'Қабылдау және өту',
    qr_code_title: 'Тапсырыс QR-коды',
    qr_code_desc: 'Официант тапсырысты жылдам қабылдауы үшін осы кодты көрсетіңіз.',
    addToStopList: 'Стоп-тізімге қосу',
    aiChefTitle: 'ЖИ-Шеф',
    order_error_title: 'Тапсырыс қатесі',
    order_error_msg: 'Тапсырысты жіберу мүмкін болмады. Қайталап көріңіз немесе даяшыны шақырыңыз.',
    enterTableNumber: 'Үстел нөмірін енгізіңіз',
    enterTableDesc: 'Тапсырыс беру үшін үстел нөмірін көрсетіңіз.',
    confirm: 'Растау',
    comment: 'Түсініктеме',
    addComment: 'Түсініктеме қосу',
    commentPlaceholder: 'Тапсырысқа тілектеріңізді жазыңыз...',
    sendComment: 'Жіберу',
    commentSent: 'Түсініктеме жіберілді!',
    orderSubmitted: 'Тапсырыс жіберілді',
    currentOrder: 'Тапсырыс берілген',
    placeOrder: 'Тапсырыс беру',
    newItems: 'Жаңа тауарлар',
    totalToPay: 'Төлеуге',
    confirmOrder: 'Тапсырысты растау',
    myBill: 'Менің чегім',
    reorder: 'Қайта тапсырыс',
    orderSentSuccess: 'Тапсырыс жіберілді!',
    newOrderTitle: 'Жаңа тапсырыс!',
    details: 'Мәліметтер',
    totalForNew: 'Жаңа тапсырыс жиыны',
    withService: 'қоса алғанда',
    order: 'Тапсырыс',
    kcal: 'Ккал',
    with_photo: 'Фотомен',
    compact_view: 'Ықшам',
    waiting: 'КҮТУДЕ',
    orderConfirmationHint: 'Тапсырыс мәліметтерін растау үшін үстелге келіңіз',
    enable_camera: 'Камераны қосу',
    table_number_placeholder: 'Үстел нөмірі',
    save_changes: 'Сақтау',
    scan_instruction: 'Тапсырысты алу үшін қонақтың QR-кодын сканерлеңіз',

    // Cover Quotes
    quote1: "Сөзбен айтып жеткізу мүмкін болмағанда, тамақ махаббаттың нышанына айналады.",
    author1: "Алан Д. Волфельт",
    quote2: "Егер адам дұрыс тамақтанбаса, ол дұрыс ойлай алмайды, жақсы көре алмайды және ұйықтай алмайды.",
    author2: "Вирджиния Вулф",
    quote3: "Тамақ ішкенді жақсы көретін жандар — әрқашан ең жақсы адамдар.",
    author3: "Джулия Чайлд",
    quote4: "Аспаздық — бұл адамдар туралы. Тамақ — бәлкім, барлығын біріктіруге күші жететін жалғыз әмбебап нәрсе.",
    author4: "Гай Фиери",

    // Stickers
    sticker_new: "ЖАҢА",
    sticker_hit: "ХИТ",
    sticker_spicy: "АЩЫ",
    sticker_vegan: "ВЕГАН",
    sticker_nuts: "ЖАҢҒАҚ",
    sticker_non_alcoholic: "Б/А",

    // Simple Login Page
    loginTitleText: 'Жүйеге кіру',
    emailOrUsername: 'Пошта/Қолданушы аты',
    showPass: 'Көрсету',
    hidePass: 'Жасыру',
    signInBtn: 'Кіру',
    agreementText1: 'Жалғастыра отырып, сіз ',
    agreementText2: ' және ',
    agreementText3: ' келісесіз.',
    privacyPolicy: 'Құпиялылық саясатымен',
    userAgreement: 'Пайдаланушы келісімімен',
    footerUserAgreement: 'Пайдаланушы келісімі',
    footerPrivacyPolicy: 'Құпиялылық саясаты',
    footerPublicOffer: 'Жария оферта',

    // Dish Form & Menu Management
    tabMain: 'Негізгі',
    tabModifiers: 'Модификаторлар',
    tabTagsNutrition: 'Белгілер және КБЖУ',
    hasVariantsTitle: 'Өлшемдері, көлемдері',
    hasVariantsDesc: 'Мысалы: 25см (400г) / 35см (750г), 250мл / 500мл',
    variantNameAndSize: 'Атауы (өлшемі / салмағы / көлемі)',
    variantPrice: 'Бағасы',
    variantPlaceholder: 'мыс. 25 см (400 г), 0.5 л',
    recommendedSize1to1: '1:1 ұсынылады',
    modePhotoCard: 'Суретпен',
    modeList: 'Тізім (суретсіз)',
    dishDescriptionPlaceholder: 'Ингредиенттерді, дәм ерекшеліктерін немесе ұсынылуын сипаттаңыз...',
    descriptionAndComposition: 'Сипаттамасы және құрамы',
    dishNamePlaceholder: 'Мысалы: 4 ірімшік пиццасы немесе Капучино',
    modifiersHint: 'Тұздықтар, қуыру дәрежесі, сироптар немесе гарнирлер қосыңыз',
    quickAdd: 'Жылдам қосу:',
    noModifiersYet: 'Бұл тағамда әзірге модификаторлар жоқ. Төмендегі батырманы басыңыз немесе жоғарыдан үлгі таңдаңыз.',
    groupNamePlaceholder: 'Топ аты (мыс. Тұздықтар)',
    deleteGroup: 'Топты жою',
    mod_optional: 'Міндетті емес',
    mod_mandatory: 'Міндетті',
    mod_multiple: 'Көп таңдау',
    optionName: 'Опция атауы',
    addOption: 'Опция қосу',
    addGroup: 'Топ қосу',
    dishTags: 'Тағам белгілері',
    dishTagsHint: 'Шарап, бар және мәзір үшін дайын белгілерді таңдаңыз немесе өзіңіздікін қосыңыз:',
    customTags: 'Өзіңіздің',
    clickToRemove: 'Жою үшін басыңыз',
    popularTags: 'Негізгі',
    wineSugar: 'Шарап',
    countryRegion: 'Ел',
    otherCountry: 'Басқа',
    searchCountryPlaceholder: 'Елді іздеу (мыс. Италия, Грузия, Қазақстан, Испания...)',
    addCountryCustom: '+ Қосу',
    whiskeyAlcohol: 'Күшті ішімдік',
    customTagPlaceholder: 'Өз белгіңіз (мыс. 12 жыл, IPA, Авторлық)',
    addTagBtn: 'Қосу',
    nutritionPer100g: '100 г тағамдық құндылығы',
    nutritionTotal: 'Тағамдық құндылығы (Жалпы)',
    characteristics: 'Сипаттамалары',
    pcs: 'дн',
    liters: 'л',
    chooseVariant: 'Нұсқаны таңдаңыз',
    removeFromStopList: 'Стоп-тізімнен алып тастау',
    returnToMenu: 'Мәзірге қайтару',
    editCategory: 'Санатты өңдеу',
    categoryNamePlaceholder: 'Мысалы: Таңғы ас',
    editSection: 'Бөлімді өңдеу',
    sectionNamePlaceholder: 'Мысалы: Бар, Асхана немесе Қорқор',
    sectionCategories: 'Бөлімдегі санаттар',
    sectionCategoriesHint: 'Осы бөлімге кіретін санаттарды белгілеңіз',
    quickAddCategoryPlaceholder: 'Осы бөлімге жаңа санат қосу...',
    inThisSection: 'Осы бөлімде',
    searchCategories: 'Санаттарды іздеу...',
    noCategoriesFound: 'Санаттар табылмады',
    dishesCountShort: 'тағ.',
    section: 'Бөлім',
    ageRestriction: '21+ шектеуі',
    ageRestrictionHint: 'Алкоголь немесе темекі өнімдері бар санаттар үшін',
    saving: 'Сақталуда...',
    start: 'Бастау',
    mapLink: '2GIS сілтемесі',
    mapLinkPlaceholder: 'https://go.2gis.com/...',
    workSchedule: 'Жұмыс кестесі',
    workingHours: 'Жұмыс уақыты',
    confirm_delete: 'Жоюды растау',
    copied: 'Көшірілді',
    statusProcessingShort: 'Дайындалуда',
    success: 'Сәтті',
    aiSommelierTitle: 'Сомелье',
    noOrders: 'Белсенді тапсырыстар жоқ',
    noOrdersText: 'Сіздің ағымдағы тапсырыстарыңыз осында көрсетіледі',
    activeOrder: 'Ағымдағы тапсырыс',
    myOrders: 'Менің тапсырыстарым',
    authSuccess: 'Аккаунт жасалды!',
    statusAccepted: 'Қабылданды',
    statusProcessing: 'Дайындалуда',
    statusOnWay: 'Жолда / Берілуге дайын',
    statusCompleted: 'Орындалды',
    statusRejected: 'Бас тартылды',
    historyAuthTitle: 'Тапсырыстар тарихы',
    historyAuthDesc: 'Тапсырыстар тарихын көру үшін жүйеге кіріңіз немесе тіркеліңіз.',
    login: 'Кіру',
    register: 'Тіркелу',
    or: 'немесе',
    loginWithGoogle: 'Google арқылы кіру',
    noAccount: 'Аккаунтыңыз жоқ па? Тіркелу',
    hasAccount: 'Аккаунтыңыз бар ма? Кіру',
    orderHistory: 'Тапсырыстар тарихы',
    emptyHistory: 'Сіз әлі тапсырыс берген жоқсыз',
    date: 'Күні',
    type: 'Түрі',
    deliveryType: 'Жеткізу',
    pickupType: 'Өзі алып кету',
    callWaiter: 'Даяшыны шақыру',
    howCanWeHelp: 'Қалай көмектесе аламыз?',
    billCard: 'Шот (Карта)',
    billCash: 'Шот (Қолма-қол)',
    requestSent: 'Сұраныс жіберілді!',
    waiterNavigating: 'Даяшы сізге қарай келе жатыр.',
    scans: 'Сессиялар',
    noDataForPeriod: 'Бұл кезеңде деректер жоқ',
    total: 'Барлығы',
    last7Days: 'Соңғы 7 күн',
    last30Days: 'Соңғы 30 күн',
    executiveSummary: 'Қорытынды',
    visitors: 'Келушілер',
    trafficVolume: 'Трафик көлемі',
    expand: 'Жаю',
    collapse: 'Жию',
    deleted: 'Жойылды',
    deleteConfirmTitle: 'Жоюды растау',
    categoryName: 'Санат атауы',
    noSection: 'Бөлімсіз',
    categoryDescriptionLabel: 'Сипаттама (мыс. ет тағамдары)',
    sectionName: 'Бөлім атауы',
    sectionsEmpty: 'Бөлімдер бос',
    addBanner: 'Баннер қосу',
    editBanner: 'Баннерді өңдеу',
    fileTooLarge: 'Файл тым үлкен (макс 5МБ)',
    errorSending: 'Жіберу қатесі: ',
    liveStats: 'Бүгінгі статистика',
    viewsToday: 'Бүгінгі қаралымдар',
    subscription: 'Жазылым',
    activity: 'Белсенділік',
    views_count: 'қаралым',
    until: 'дейін',
    hoursShort: 'сағ',
    unknownDish: 'Белгісіз тағам',
    unlimited: 'Шексіз',
    expired: 'мерзімі бітті',
    expiringSoon: 'жақында аяқталады',
    extend: 'Ұзарту',
    daysShort: 'күн',
    gracePeriodActive: 'Жеңілдік кезеңі белсенді',
    remaining: 'қалды',
    renewToKeepAccess: 'Қолжетімділікті сақтау үшін жазылымды ұзартыңыз',
    analyticsLocked: 'Аналитика құлыпталған',
    availableInPlans: 'Тарифтерде қолжетімді',
    viewTariffs: 'Тарифтерді қарау',
    and: 'және',
    marketingToolsDesc: 'Мекемеңізге арналған озық маркетинг құралдары.',
    activeBanners: 'Белсенді баннерлер',
    availableInSmart: 'Smart тарифінде қолжетімді',
    addVariant: 'Нұсқа қосу',
    noBanners: 'Баннерлер жоқ. Оларды баптаулардан қосыңыз.',
    gridView: 'Тор',
    listView: 'Тізім',
    downloadReport: 'Есепті PDF түрінде жүктеу',
    outsidersDesc: 'Төмен трафикті позициялар',
    guestsSearchingDesc: 'Қонақтар іздейтін тағамдар',
    noViewsDesc: 'Қаралымы жоқ позициялар',
    lightTheme: 'Ашық тақырып',
    darkTheme: 'Күңгірт тақырып',
    manageSections: 'Бөлімдерді басқару',
    attention: 'Назар аударыңыз',
    thisCategory: 'осы санатты',
    owner: 'Иесі',
    notSpecified: 'Көрсетілмеген',
    errorSendingRequest: 'Сұраныс жіберу қатесі',
    dishLimitReached: '%plan% тарифіндегі тағамдар шегі таусылды (%limit%). Шексіз болу үшін Smart тарифіне өтіңіз.',
    ageGateTitle: '21+ алкогольді сусындар',
    ageGateMessage: 'Бұл санатты көру үшін жасыңыз 21-де екенін растаңыз',
    ageGateConfirm: 'Растаймын',
    modifierName: 'Атауы (мыс. Ірімшік)',
    noModifiers: 'Модификаторлар жоқ',
    addModifier: 'Модификатор қосу',
    from: 'бастап ',
    variantNamePlaceholder: 'Атауы (мыс. Құлпынай)',
    variantSizePlaceholder: 'Атауы (мыс. 30 см)',
    dishImage: 'Тағам суреті',
    saveAsDraft: 'Жобаға сақтау',
    bannersLabel: 'Баннерлер',
    chooseOne: 'Біреуін таңдаңыз',
    chooseMultiple: 'Бірнешеуін таңдауға болады',
    pleaseSelect: 'Таңдаңыз',
    min: 'мин.',
    max: 'макс.',
    withPercent: '*пайыздарды қосқанда',
    yourPhone: 'Телефон нөмірі',
    yourCafeName: 'Мекеме атауы',
    sendRequest: 'Өтініш жіберу',
    requestSentTitle: 'Өтініш жіберілді',
    requestSentMessage: 'Біз сізбен жақын арада байланысамыз!',
    fillAllFields: 'Барлық өрістерді толтырыңыз',
    yourTelegram: 'Сіздің Telegram (@username)',
    excludeIngredients: 'Ингредиенттерді алып тастау',
    catGrill: 'Мангал / Гриль',
    catBeerSnacks: 'Сыраға арналған тіскебасарлар',
    catWineList: 'Шарап картасы',
    catSpirits: 'Күшті алкоголь',
    catSoftDrinks: 'Алкогольсіз сусындар',
    catLemonades: 'Лимонадтар мен Смузи',
    catPlatters: 'Компанияға арналған тағамдар',
    catSeasonal: 'Маусымдық мәзір',
    catVegan: 'Вегетариандық мәзір',
    catHookah: 'Кальян',
    catOriental: 'Шығыс тағамдары',
    catPanAsian: 'Паназиялық тағамдар',
    catGeorgian: 'Грузин тағамдары',
    catEuropean: 'Еуропа тағамдары',
    takeAway: 'Өзімен бірге',
    dineIn: 'Мекемеде',
    noGarlic: 'Сарымсақсыз',
    noHerbs: 'Көкөніссіз / Аскөксіз',
    extraSauce: 'Қосымша тұздық',
    duplicate: 'Көшірмесін жасау',
    qrStyleSquare: 'Квадрат',
    qrStyleRounded: 'Дөңгеленген',
    qrStyleDots: 'Нүктелер',
    qrStyleClassy: 'Классика',
    qrStyleClassyRounded: 'Классика (дөңг.)',
    qrStyleExtraRounded: 'Қатты дөңгеленген',
    qrStyleDot: 'Нүкте',
    'qrColor.pattern': 'Өрнек',
    'qrColor.background': 'Фон',
    'qrColor.eyeFrame': 'Көз жақтауы',
    'qrColor.eyeDot': 'Көз нүктесі',
    qrColorFrame: 'Жақтау',
    qrColorText: 'Мәтін',
    mon: 'Дс',
    tue: 'Сс',
    wed: 'Ср',
    thu: 'Бс',
    fri: 'Жм',
    sat: 'Сб',
    sun: 'Жс',
    everyDay: 'Күн сайын',
    weekdays: 'Жұмыс күндері',
    weekend: 'Демалыс күндері',
    isClosed: 'Жабық',
    open24h: 'Тәулік бойы',
    variant: 'Нұсқа',
    in_hall: 'Залда',
    scan: 'Сканерлеу',
    availableMsg: 'Қолжетімді',
    unavailableMsg: 'Қолжетімсіз',
    checkout: 'Тапсырысты ресімдеу',
    contacts: 'Байланыс деректері',
    yourNamePlaceholder: 'Сізге қалай жүгінуге болады?',
    whereToDeliver: 'Қайда жеткізу керек?',
    addressPlaceholder: 'Көше, үй, пәтер',
    sendOrder: 'Тапсырыс беру',
    enterNameAlert: 'Атыңызды көрсетіңіз.',
    enterPhoneAlert: 'Телефон нөмірін толық енгізіңіз.',
    enterAddressAlert: 'Жеткізу мекенжайын көрсетіңіз.',

    // Characteristics & Pills
    pill_wine_red: 'Қызыл',
    pill_wine_red_desc: 'Қызыл шарап - қара жүзім сорттарынан жасалған, қанық дәмге және таниндерге ие.',
    pill_wine_white: 'Ақ',
    pill_wine_white_desc: 'Ақ шарап - жеңіл әрі сергітетін, ақ жүзімнен немесе қара жүзімнің тазартылған шырынынан жасалады.',
    pill_wine_rose: 'Қызғылт',
    pill_wine_rose_desc: 'Қызғылт шарап - қара жүзім қабығымен қысқа жанасу арқылы алынатын хош иісті шарап.',
    pill_wine_dry: 'Құрғақ',
    pill_wine_dry_desc: 'Құрғақ шарап - қант мөлшері 4 г/л дейін, айқын қышқылдығы бар табиғи дәм.',
    pill_wine_semidry: 'Жартылай құрғақ',
    pill_wine_semidry_desc: 'Жартылай құрғақ шарап - қант мөлшері 4-18 г/л, жеңіл тәттілік пен балғындықтың үйлесімі.',
    pill_wine_semisweet: 'Жартылай тәтті',
    pill_wine_semisweet_desc: 'Жартылай тәтті шарап - қант мөлшері 18-45 г/л, жұмсақ тәтті дәм.',
    pill_wine_sweet: 'Тәтті',
    pill_wine_sweet_desc: 'Тәтті шарап - десертті шарап, қант мөлшері 45 г/л жоғары.',
    pill_wine_brut: 'Брют',
    pill_wine_brut_desc: 'Брют - қант мөлшері өте аз құрғақ газдалған шарап.',

    pill_spirits_singlemalt: 'Single Malt',
    pill_spirits_singlemalt_desc: 'Single Malt (Бір уытты) - бір дистиллерияда тек 100% арпа уытынан өндірілген виски.',
    pill_spirits_blended: 'Blended',
    pill_spirits_blended_desc: 'Blended (Купаждалған) - уытты және дәнді дистилляттардың үйлесімді қоспасынан жасалған виски.',
    pill_spirits_singlegrain: 'Single Grain',
    pill_spirits_singlegrain_desc: 'Single Grain (Бір дәнді) - бір дистиллерияда бидай, жүгері немесе қарабидайдан жасалған виски.',
    pill_spirits_blendedmalt: 'Blended Malt',
    pill_spirits_blendedmalt_desc: 'Blended Malt - әр түрлі дистиллериялардың бір уытты вискилерінің купажы.',
    pill_spirits_singlepotstill: 'Single Pot Still',
    pill_spirits_singlepotstill_desc: 'Single Pot Still - ирландиялық дәстүрлі арпа вискиі.',

    country_ireland: 'Ирландия',
    country_ireland_desc: 'Ирландия - үш мәрте дистилляцияланған жұмсақ вискидің және классикалық сусындардың отаны.',
    country_scotland: 'Шотландия',
    country_scotland_desc: 'Шотландия - емен бөшкелерде сақталатын ғасырлық дәстүрлі скотчтың отаны.',
    country_france: 'Франция',
    country_france_desc: 'Франция - шарап жасаудың, коньяктың және жоғары дәрежелі аперитивтердің әлемдік эталоны.',
    country_usa: 'АҚШ',
    country_usa_desc: 'АҚШ / Америкалық стиль - жаңа күйдірілген емен бөшкелердегі дәстүрлі жүгері бурбонымен танымал.',
    country_american: 'Америка',
    country_japan: 'Жапония',
    country_japan_desc: 'Жапония - бөлшектерге ерекше мән беретін нәзік әрі үйлесімді дистилляция стилі.',
    country_japanese: 'Жапония',
    country_italy: 'Италия',
    country_italy_desc: 'Италия - әйгілі аперитивтер, вермуттар және жерорта теңізілік шараптардың отаны.',
    country_spain: 'Испания',
    country_spain_desc: 'Испания - кава, херес және бай гастрономиялық дәстүрлері бар жарқын шараптар елі.',
    country_georgia: 'Грузия',
    country_georgia_desc: 'Грузия - 8000 жылдық тарихы және квевриде сақтау дәстүрі бар шарап жасаудың бесігі.',
    country_germany: 'Германия',
    country_germany_desc: 'Германия - мінсіз қышқылдығы мен минералды тепе-теңдігі бар ұлы рислингтердің отаны.',
    country_kazakhstan: 'Қазақстан',
    country_kazakhstan_desc: 'Қазақстан - заманауи стандарттар мен сапаны сақтаған отандық өнім.',
    country_chile: 'Чили',
    country_chile_desc: 'Чили - Карменер сортының және қанық жемісті шараптардың отаны.',
    country_portugal: 'Португалия',
    country_portugal_desc: 'Португалия - атақты портвейн, балғын Винью Верде шараптарының отаны.',
    country_mexico: 'Мексика',
    country_mexico_desc: 'Мексика - көгілдір агавадан жасалған дәстүрлі текила мен мескальдың отаны.',
    country_china: 'Қытай',
    country_china_desc: 'Қытай - дәстүрлі сусындар мен заманауи крафтық өндіріс.',
    country_korea: 'Корея',
    country_korea_desc: 'Корея - соджу мен дәстүрлі күріш сусындарының отаны.',
    country_argentina: 'Аргентина',
    country_argentina_desc: 'Аргентина - Мендоса биік таулы аймағының қуатты Мальбек шарабының отаны.',
    country_australia: 'Австралия',
    country_australia_desc: 'Австралия - қанық Шираз және заманауи шарап жасау дәстүрлерімен әйгілі.',
    country_new_zealand: 'Жаңа Зеландия',
    country_new_zealand_desc: 'Жаңа Зеландия - жарқын хош иісті Совиньон Блан шараптарының эталоны.',
    country_austria: 'Австрия',
    country_austria_desc: 'Австрия - Грюнер Вельтлинер және талғампаз минералды шараптардың отаны.',
    country_greece: 'Грекия',
    country_greece_desc: 'Грекия - антикалық шарап жасаудың және бірегей аралдық сорттардың отаны.',
    country_czech: 'Чехия',
    country_czech_desc: 'Чехия - классикалық лагерлер мен дәстүрлі сусындардың отаны.',
    country_belgium: 'Бельгия',
    country_belgium_desc: 'Бельгия - ғасырлық дәстүрі бар монастырьлық және траппистік сусындардың астанасы.',
    country_switzerland: 'Швейцария',
    country_switzerland_desc: 'Швейцария - таза тау суы мен жоғары сапа стандарттарына негізделген өнім.',
    country_netherlands: 'Нидерланды',
    country_netherlands_desc: 'Нидерланды - женевер мен дәстүрлі дистилляттардың отаны.',
    country_south_africa: 'ОАР',
    country_south_africa_desc: 'ОАР - әйгілі Пинотаж және Шенен Блан шараптарының отаны.',
    country_turkey: 'Түркия',
    country_turkey_desc: 'Түркия - шығыстың бай дәмдеуіштері мен жемісті ноталары бар сусындар.',
    country_uzbekistan: 'Өзбекстан',
    country_uzbekistan_desc: 'Өзбекстан - күн сәулесі мол, дәстүрлі тәтті шараптар мен тұнбалар елі.',
    country_armenia: 'Армения',
    country_armenia_desc: 'Армения - аңызға айналған коньяк пен көне Арени сорттарының отаны.',
    country_azerbaijan: 'Әзірбайжан',
    country_azerbaijan_desc: 'Әзірбайжан - күнге піскен жүзім мен анар сусындарының каспийлік отаны.',
    countryOfOriginTpl: 'Шыққан елі: %country%. Аймақтың дәстүрлі сапа стандарттарына сай сусын.',
    drinkFeatureTpl: 'Сусынның ерекшелігі: %tag%',
    unsavedChangesTitle: 'Сақталмаған өзгерістер',
    unsavedChangesMessage: 'Сізде сақталмаған өзгерістер бар. Шығу алдында оларды сақтағыңыз келе ме, әлде сақтамай жабасыз ба?',
    saveAndClose: 'Сақтау',
    discardAndClose: 'Сақтамай жабу',
    continueEditing: 'Бас тарту'
};

export default kz;
